// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"141":"b76e1907","247":"755d7f67","738":"8d629b77","936":"15d9156d"}[chunkId] + ".chunk.css";
};